import moment from 'moment';
import React from 'react';
import { Col, Label, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CustomSearchBox } from '../CustomControls/CustomSearchBox';
import { dateFormatter, yesNoFormatter } from '../Utils/Formatter';
import { EntryItemsTable } from './EntryItemsTable';

export const PersonalHistory = (props) => {
    const { t } = useTranslation();

    const columns = [
        {
            dataField: 'adverseEffect', text: t('medicalRecords.adverseEvents.adverseEvent'), formatter: function (_cell, row, rowindex) {
                return (

                    <Row key={`adverseEvent-item-${rowindex}`} style={{ textAlign: 'left' }} className="item-data">
                        <Col md={8}>
                            <span className="item-text">{row.adverseEffect}</span>
                            {
                                (row.from || row.to) &&
                                <div>
                                    {row.from && <span><span className="item-label">{t('medicalRecords.from')}:</span> <span className="item-text">{row.from}</span></span>}
                                    {row.from && row.to && <span>&nbsp;&nbsp;</span>}
                                    {row.to && <span><span className="item-label">{t('medicalRecords.to')}:</span> <span className="item-text">{row.to}</span></span>}
                                </div>
                            }
                        </Col>
                        <Col md={4} style={{ textAlign: 'right' }}>
                            <div><span className="item-label">{t('medicalRecords.itemDates.created')}:</span> <span className="item-text">{dateFormatter(row.created, "DD/MM/YY")}</span></div>
                            {
                                moment(row.modified).format("DD/MM/YY") !== moment(row.created).format("DD/MM/YY") &&
                                <div><span className="item-label">{t('medicalRecords.itemDates.modified')}:</span> <span className="item-text">{dateFormatter(row.modified, "DD/MM/YY")}</span></div>
                            }
                            {row.toYear && row.entryId == props.entryId &&
                                <div><Label bsStyle="danger">{t('medicalRecords.itemDates.closedHere')}</Label></div>
                            }
                        </Col>
                    </Row>
                )
            }
        },
    ];

    const expandedContent = (row) => (
        <div className="info">
            {row.intensity && <div><span className="patient-label">{t('medicalRecords.adverseEvents.intensity')}:</span> <span className="patient-text">{row.intensity}</span></div>}
            {row.action && <div><span className="patient-label">{t('medicalRecords.adverseEvents.action')}:</span> <span className="patient-text">{row.action}</span></div>}
            {row.serious && <div><span className="patient-label">{t('medicalRecords.adverseEvents.serious')}:</span> <span className="patient-text">{row.serious}</span></div>}
            {row.relationwithdrug && <div><span className="patient-label">{t('medicalRecords.adverseEvents.relationwithdrug')}:</span> <span className="patient-text">{row.relationwithdrug}</span></div>}
            {row.reported && <div><span className="patient-label">{t('medicalRecords.adverseEvents.reported')}:</span> <span className="patient-text">{yesNoFormatter(row.reported, t)}</span></div>}
            {row.notes && <div><span className="patient-label">{t('medicalRecords.adverseEvents.notes')}:</span> <span className="patient-text">{row.notes}</span></div>}
        </div>
    )

    const rowClasses = (row) => { return row.logicalItemId && row.logicalItemId !== row.id ? 'item-modified' : ''; };

    return (
        <>
            {props.onSearchTermChange && <CustomSearchBox handleSearch={props.onSearchTermChange} placeholder={t('medicalRecords.searchByName')} />}
            <EntryItemsTable columns={columns} {...props} rowClasses={rowClasses} expandContent={expandedContent} />
        </>
    );
}